"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.function.bind.js");

require("core-js/modules/es.object.get-prototype-of.js");

require("core-js/modules/es.object.set-prototype-of.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _componentLoader = _interopRequireDefault(require("@bythepixel/component-loader"));

var _runInView = _interopRequireDefault(require("@bythepixel/run-in-view"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var InViewSrc = /*#__PURE__*/function (_Component) {
  _inherits(InViewSrc, _Component);

  var _super = _createSuper(InViewSrc);

  function InViewSrc(element) {
    var _this;

    _classCallCheck(this, InViewSrc);

    _this = _super.call(this, element);

    _this.boundCleanup = function () {
      return _this.cleanup();
    };

    _this.boundRemoveMaskStyles = function () {
      return _this.removeMaskStyles();
    };

    _this.init.bind(_assertThisInitialized(_this));

    _this.$state = {
      initialized: false
    };
    (0, _runInView["default"])(_this.$container, function () {
      return _this.init();
    });
    return _this;
  }

  _createClass(InViewSrc, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      if (this.$state.initialized) return;
      this.$state.initialized = true;
      this.$container.addEventListener('load', this.boundRemoveMaskStyles);
      requestAnimationFrame(function () {
        _this2.$container.src = _this2.$container.dataset.src;
      });
    }
  }, {
    key: "removeMaskStyles",
    value: function removeMaskStyles() {
      var _this3 = this;

      this.$container.addEventListener('transitionend', this.boundCleanup);
      requestAnimationFrame(function () {
        _this3.$container.style.transition = 'opacity 500ms ease-out';

        _this3.$container.style.setProperty('--image-opacity', 'initial');
      });
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      var _this4 = this;

      this.$container.removeEventListener('load', this.boundCleanup);
      requestAnimationFrame(function () {
        _this4.$container.removeAttribute(InViewSrc.selector.replace(/[[\]']+/g, ''));

        _this4.$container.style.transition = null;
      });
    }
  }]);

  return InViewSrc;
}(_componentLoader["default"]);

InViewSrc.selector = '[data-src]';
var _default = InViewSrc;
exports["default"] = _default;
//# sourceMappingURL=index.js.map